import { ChevronDownIcon, Client } from '@umanforge/common';
import { useTranslation } from 'react-i18next';
import ClientPopup from './clientPopup.component';

interface ClientSelectorProps {
  selected: Client | null;
  otherClients: Client[];
  toggle: () => void;
  showPopup: boolean;
  onClientClick: ( client: Client ) => void;
  popupRef: React.RefObject<HTMLSpanElement>;
  buttonRef: React.RefObject<HTMLButtonElement>;
  isClickable: boolean;
  className?: string;
}

function ClientSelector( {
  selected,
  otherClients,
  toggle,
  showPopup,
  onClientClick,
  popupRef,
  buttonRef,
  className = '',
}: ClientSelectorProps ) {
  const { t } = useTranslation();
  const hasMultipleClients = otherClients.length > 0;
  const hasNoClients = !selected && otherClients.length === 0;

  return (
    <button
      className={`font-comfortaa text-5xl mr-4 relative ${!hasMultipleClients ? 'cursor-default opacity-60' : 'cursor-pointer'} flex items-center ${className}`}
      onClick={hasMultipleClients ? toggle : undefined}
      ref={buttonRef}
      disabled={!hasMultipleClients}
      type="button"
    >
      {hasNoClients ? (
        <span className="text-gray-400 italic text-lg">{t( 'common:no_client_available' )}</span>
      ) : (
        selected?.name || t( 'common:no_client_selected' )
      )}
      {hasMultipleClients && (
        <span
          className={`ml-2 text-5xl select-none transition-transform duration-200 ease-in-out ${showPopup ? 'rotate-180' : 'rotate-0'}`}
          aria-label="changer de client"
          style={{ display: 'inline-block' }}
        >
          <ChevronDownIcon />
        </span>
      )}
      {showPopup && (
        <ClientPopup clients={otherClients} onSelect={onClientClick} popupRef={popupRef} />
      )}
    </button>
  );
}

export default ClientSelector;
